export default __webpack_public_path__ + "static/media/back.b99e20c6.svg";